import useTranslate from "hooks/useTranslate";
import { Swiper, SwiperSlide } from "swiper/react";
import { LoyaltyRewardHelp } from "components/molecules/LoyaltyRewardHelp";
import { LoyaltyMoreRewardCard } from "components/molecules/LoyaltyMoreRewardCard";
import { mapRewards } from "mappings/loyaltyRewards";
import { useMemo } from "react";
import url from "../../../url";
import "./styles.sass";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { LoyaltyRewardsBFF } from "../../../types/LoyaltyBFF";

export const LoyaltyMoreRewards = ({
  rewardsNextRank,
}: {
  rewardsNextRank?: LoyaltyRewardsBFF | null;
}) => {
  const t = useTranslate();
  const redirectUrl = url.routes.profile.bonus();
  const { isPhone } = useBreakpoint();

  const rankRewards = useMemo(() => {
    if (!rewardsNextRank) {
      return [];
    }
    const all = mapRewards(rewardsNextRank).filter(
      (r) => r.variant !== "booster",
    );
    const cashbackVariants = [
      "cashbackDaily",
      "cashbackWeekly",
      "cashbackMonthly",
    ];
    const cashback = cashbackVariants
      .map((v) => all.find((r) => r.variant === v))
      .find(Boolean);
    return [
      ...all.filter((r) => !cashbackVariants.includes(r.variant)),
      ...(cashback ? [cashback] : []),
    ];
  }, [rewardsNextRank]);

  const helpBlock = (
    <LoyaltyRewardHelp
      text="loyalty.redesign.1.more.reward.help.title"
      bntText="loyalty.redesign.1.more.reward.help.btn.text"
      background="var(--primary)"
      redirectUrl={redirectUrl}
    />
  );

  if (!rewardsNextRank) {
    return <div className="LoyaltyMoreRewards">{helpBlock}</div>;
  }

  const mapCards = (list: typeof rankRewards) => (
    <>
      {list.map((card) => (
        <LoyaltyMoreRewardCard key={card.id} {...card} />
      ))}
    </>
  );

  const content = isPhone ? (
    <div className="LoyaltyMoreRewards__cards">
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        freeMode
        init={false}
        grabCursor
      >
        {rankRewards.map((card) => (
          <SwiperSlide key={card.id} className="LoyaltyMoreRewards__card">
            <LoyaltyMoreRewardCard {...card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  ) : (
    <div className="LoyaltyMoreRewards__cardsGrid">{mapCards(rankRewards)}</div>
  );

  return (
    <div className="LoyaltyMoreRewards">
      <h2 className="LoyaltyMoreRewards__header">
        {t("loyalty.redesign.1.rewards-next-block.title")}
      </h2>
      {content}
      {helpBlock}
    </div>
  );
};
